import { POST } from './API';

const PATH_ROOT = 'U003';

export type A01Output = {
  notifications: {
    notice_id: number;
    start_dtm: Date;
    notice_title: string;
    notice: string;
    file1: string | undefined;
    file2: string | undefined;
    file3: string | undefined;
    file4: string | undefined;
    file5: string | undefined;
  }[];
};
export async function A01(userId: string, lang: string, cancellation?: AbortSignal) {
  return await POST(`${PATH_ROOT}/notifications`, {
    user_id: userId,
    lang: lang,
    limit: 100,
    signal: cancellation,
  });
}
export async function A02(userId: string, lang: string, cancellation?: AbortSignal) {
  return await POST(`${PATH_ROOT}/news`, {
    user_id: userId,
    lang: lang,
    limit: 100,
    signal: cancellation,
  });
}
export type A03Input = {
  user_id: string;
  lang: string;
};
export type A03Output = {
  auditions: {
    id: string;
    title: string;
    applicant_dtm: string;
  }[];
};
export async function A03(
  userId: A03Input['user_id'],
  lang: A03Input['lang'],
  cancellation?: AbortSignal
): Promise<A03Output> {
  return await POST(`${PATH_ROOT}/auditions`, {
    user_id: userId,
    lang: lang,
    limit: 100,
    signal: cancellation,
  });
}

export type A04Input = {
  user_id: string;
  filePath: string;
};
export async function A04(A04Input: A04Input, cancellation?: AbortSignal) {
  return await POST(`${PATH_ROOT}/attached_file`, {
    user_id: A04Input.user_id,
    file_path: A04Input.filePath,
    signal: cancellation,
  });
}
